import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useUiStore = create(
  persist(
    (set, get) => ({
      sidebarOpen: true,
      sidebarCollapsed: false,
      sidebarGroups: { brevo: true },
      agentPanelOpen: false,
      theme: 'light',  // 'light' | 'dark' | 'system'
      isMobile: false,
      selectedLanguage: null,  // null = org_default

      toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
      setSidebarOpen: (open) => set({ sidebarOpen: open }),
      toggleSidebarCollapse: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
      toggleSidebarGroup: (key) => set((s) => ({ sidebarGroups: { ...s.sidebarGroups, [key]: !s.sidebarGroups[key] } })),
      toggleAgentPanel: () => set((s) => ({ agentPanelOpen: !s.agentPanelOpen })),
      setAgentPanelOpen: (open) => set({ agentPanelOpen: open }),
      setIsMobile: (isMobile) => set({ isMobile }),
      setSelectedLanguage: (language) => set({ selectedLanguage: language }),

      setTheme: (theme) => {
        set({ theme });
        applyTheme(theme);
      },

      toggleTheme: () => {
        const current = get().theme;
        const next = current === 'light' ? 'dark' : 'light';
        set({ theme: next });
        applyTheme(next);
      },

      initTheme: () => {
        const theme = get().theme;
        applyTheme(theme);
      }
    }),
    {
      name: 'mktos-ui',
      partialize: (state) => ({ theme: state.theme, sidebarOpen: state.sidebarOpen, sidebarCollapsed: state.sidebarCollapsed, sidebarGroups: state.sidebarGroups, selectedLanguage: state.selectedLanguage })
    }
  )
);

function applyTheme(theme) {
  const root = document.documentElement;
  if (theme === 'system') {
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    root.classList.toggle('dark', prefersDark);
  } else {
    root.classList.toggle('dark', theme === 'dark');
  }
}

export default useUiStore;
